<template>
	<div class="row offers mt-2">
		<b-col lg="12">
			<div class="card">
				<b-row align-h="center">
					<b-col lg="6">
						<div class="p-2">
							<div class="mt-2 text-center">Search Customer Support</div>
							<b-input-group class="mt-3">
								<b-form-input
									v-model="query_search"
									type="search"
									placeholder="Type to search"
									@change="setQuerySearch"
									trim
								></b-form-input>
								<b-input-group-append>
									<b-button type="submit" variant="primary" @click="asyncFind">Search</b-button>
									<b-button type="button" variant="dark" class="ml-2" @click="asyncClearFind">Clear</b-button>
									<b-spinner v-show="isLoadingSearch" variant="dark" class="ml-2" label="Loading .."></b-spinner>
								</b-input-group-append>
							</b-input-group>
						</div>
					</b-col>
				</b-row>
				<div class="card-body">
					<b-row class="justify-content-end">
						<span class="pr-2">
							<router-link class="btn btn-sm btn-dark" :to="{name: CustomerSupportCreatePath.name}">
                <em class="fa fa-plus"></em>
              </router-link>
						</span>
						<span>
							<button class="btn btn-sm btn-dark" @click="actionGetCustomerSupport">
								<em class="fa fa-refresh"></em>
							</button>
						</span>
						<label for="" class="col-sm-auto">Count </label>
						<strong class="col-sm-auto">{{ totalRows }}</strong>
					</b-row>
					<b-table
						:items="items"
						:fields="fields"
						:busy="isLoading"
						:isLoading="isLoading"
						show-empty
						responsive
						class="mt-3"
						hover
					>
						<template v-slot:table-busy>
							<div class="text-center text-dark my-2">
								<b-spinner
									class="align-middle"
									variant="dark"
									type="grow"
									label="Loading .."
								>
								</b-spinner>
								Loading ..
							</div>
						</template>
						<template #cell(No)="row">
							{{ (currentPage - 1) * perPage + (row.index + 1) }}
						</template>
						<template #cell(full_name)="row">
							{{ row.item.full_name }}
						</template>
						<template #cell(email)="row">
							{{ row.item.email }}
						</template>
						<template #cell(phone_number)="row">
							{{ row.item.phone_number }}
						</template>
						<template #cell(action_delete)="row">
							<b-button
								variant="danger"
								@click="actionDeleteCustomerSupport(row.item.id)"
							><em class="fa fa-remove"></em> Delete</b-button>
						</template>
					</b-table>
				</div>
				<b-row v-if="(totalRows/perPage) > 1" class="justify-content-start ml-1">
					<b-col lg="3">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							aria-controls="my-table"
						/>
					</b-col>
				</b-row>
			</div>
		</b-col>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CustomerSupportCreatePath } from "../../router/account";
export default {
	name: "access-customer-support",
	data() {
		return {
			CustomerSupportCreatePath,
			currentPage: 1,
			perPage: 20,
			query_search: '',
			isLoadingSearch: false,
			fields: [
				{ key: "No", label: "No" },
				{
					key: "full_name",
					label: "Full Name",
				},
				{
					key: "email",
					label: "Email",
				},
				{
					key: "phone_number",
					label: "Phone Number",
				},
				{ key: "action_delete", label: "Option" },
			],
		};
	},
	computed: {
		...mapState({
			isLoading: (state) => state.accessCustomerSupport.isLoading,
			items: (state) => state.accessCustomerSupport.items,
			isError: (state) => state.accessCustomerSupport.isError,
			totalRows: (state) => state.accessCustomerSupport.totalRows,
		}),
	},
	mounted() {
		this.actionGetCustomerSupport();
	},
	watch: {
		currentPage: function() {
			this.actionGetCustomerSupport();
		},
	},
	methods: {
		...mapActions("accessCustomerSupport", ["fetchCustomerSupport", "searchCustomerSupport", "deleteCustomerSupport"]),
		actionGetCustomerSupport() {
			if (this.query_search == "") {
				let payload = {
					page: this.currentPage,
					limit: this.perPage,
				};
				this.fetchCustomerSupport(payload);
			} else {
				this.asyncFind();
			}
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		setQuerySearch(query) {
			clearTimeout(this.debounce);
			this.debounce = setTimeout(() => {
				this.query_search = query;
			}, 1000);
		},
		messageAlert(icon, title, timer = 3000) {
			this.$swal({
				toast: "true",
				position: "top-end",
				icon,
				title,
				showConfirmButton: false,
				timer,
				timerProgressBar: true,
			});
		},
		asyncFind() {
			this.isLoadingSearch = true;
			clearTimeout(this.debounce);
			this.debounce = setTimeout(() => {
				const query = this.query_search;
				if (!query) {
					this.actionGetCustomerSupport();
					this.isLoadingSearch = false;
					return;
				}
				this.searchCustomerSupport({
					q: query,
					page: this.currentPage,
					limit: this.perPage,
				})
					.then((response) => {
						this.items = response.data.data.rows;
						this.isLoadingSearch = false;
					})
					.catch(() => {
						this.isLoadingSearch = false;
					});
			}, 1000);
		},
		asyncClearFind() {
			this.query_search = "";
			this.actionGetCustomerSupport();
			this.isLoadingSearch = false;
		},
		actionDeleteCustomerSupport(idUser) {
			this.$swal({
				title: "Are you sure?",
				text: "You won't be able to revert this!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes, delete it!",
			}).then((result) => {
				if (result.isConfirmed) {
					this.deleteCustomerSupport({ id: idUser })
					.then(() => {
						this.messageAlert("success", "Access has been deleted.");
						this.actionGetCustomerSupport();
					})
					.catch((error) => {
						this.messageAlert("error", error.message);
					});
				}
			});
		},
	},
};
</script>
